<template>
    <nav class="my-3">
        <ul class="pagination float-left">

            <li class="page-item" :class="{disabled: page && page.prev_page_url == null}">
                <a class="page-link"
                   href="javascript:void(0)"
                   @click="pageClick(page.prev_page_url)">قبلی</a>
            </li>

            <li class="page-item" :class="{disabled: page && page.next_page_url == null}">
                <a class="page-link"
                   href="javascript:void(0)"
                   @click="pageClick(page.next_page_url)">بعدی</a>
            </li>

        </ul>
    </nav>
</template>

<script>
    export default {
        name: "pagination",
        props: ['value', 'page'],
        methods: {
            pageClick(url) {
                if (url) {
                    this.$emit('input', url);
                    this.$emit('changePage');
                }
            }

        }
    }
</script>

<style scoped>
    .page-item:first-child .page-link {
        margin-left: 0;
        border-top-left-radius: 0.0rem;
        border-bottom-left-radius: 0.0rem;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }

    .page-item:last-child .page-link {
        border-top-right-radius: 0.0rem;
        border-bottom-right-radius: 0.0rem;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue